<template>
  <div>
    <div v-if="!reportsList.length" class="userCodeShowReport">
      <input class="inputMargin" type="text" placeholder="code animateur" v-model="userCode">
      <input type="submit" @click="getMyReports">
      <p class="error">{{error}}</p>
    </div>
    <div v-else>
      <button @click="optionShow=!optionShow">option du tableau</button>

      <div class="reportElemToShowOption" v-if="optionShow">
        <p
          :class="showItems.animatorName ? 'active':'none'"
          @click="showItems.animatorName = !showItems.animatorName"
        >
          animateur
          <input type="checkbox" v-model="showItems.animatorName">
        </p>
        <p
          :class="showItems.activitiesDetails ? 'active':'none'"
          @click="showItems.activitiesDetails = !showItems.activitiesDetails"
        >
          activités
          <input type="checkbox" v-model="showItems.activitiesDetails">
        </p>
        <p
          :class="showItems.appreciationRating ? 'active':'none'"
          @click="showItems.appreciationRating = !showItems.appreciationRating"
        >
          note
          <input type="checkbox" v-model="showItems.appreciationRating">
        </p>
        <p
          :class="showItems.appreciationDetails ? 'active':'none'"
          @click="showItems.appreciationDetails = !showItems.appreciationDetails"
        >
          appréciation
          <input type="checkbox" v-model="showItems.appreciationDetails">
        </p>
        <p
          :class="showItems.hadBugs ? 'active':'none'"
          @click="showItems.hadBugs = !showItems.hadBugs"
        >
          bug rencontré
          <input type="checkbox" v-model="showItems.hadBugs">
        </p>
        <p
          :class="showItems.bugsDetails ? 'active':'none'"
          @click="showItems.bugsDetails = !showItems.bugsDetails"
        >
          détails des bugs
          <input type="checkbox" v-model="showItems.bugsDetails">
        </p>
        <p
          :class="showItems.establishment ? 'active':'none'"
          @click="showItems.establishment = !showItems.establishment"
        >
          établissement
          <input type="checkbox" v-model="showItems.establishment">
        </p>
        <p
          :class="showItems.fromTime ? 'active':'none'"
          @click="showItems.fromTime = !showItems.fromTime"
        >
          de
          <input type="checkbox" v-model="showItems.fromTime">
        </p>
        <p
          :class="showItems.toTime ? 'active':'none'"
          @click="showItems.toTime = !showItems.toTime"
        >
          à
          <input type="checkbox" v-model="showItems.toTime">
        </p>
        <p
          :class="showItems.participantCount ? 'active':'none'"
          @click="showItems.participantCount = !showItems.participantCount"
        >
          participants
          <input type="checkbox" v-model="showItems.participantCount">
        </p>
        <p
          :class="showItems.remarks ? 'active':'none'"
          @click="showItems.remarks = !showItems.remarks"
        >
          remarque
          <input type="checkbox" v-model="showItems.remarks">
        </p>
        <p :class="showItems.type ? 'active':'none'" @click="showItems.type = !showItems.type">
          type
          <input type="checkbox" v-model="showItems.type">
        </p>
      </div>
      <div class="reportElemToShow">
        <p v-if="showItems.animatorName">animateur</p>
        <p v-if="showItems.activitiesDetails">activités</p>
        <p v-if="showItems.appreciationRating">note</p>
        <p v-if="showItems.appreciationDetails">appréciation</p>
        <p v-if="showItems.hadBugs">bug rencontré</p>
        <p v-if="showItems.bugsDetails">détails des bugs</p>
        <p v-if="showItems.establishment">établissement</p>
        <p v-if="showItems.fromTime">de</p>
        <p v-if="showItems.toTime">à</p>
        <p v-if="showItems.participantCount">participants</p>
        <p v-if="showItems.remarks">remarque</p>
        <p v-if="showItems.type">type</p>
      </div>
      <div class="reportsList">
        <div v-for="(report,index) in reportsList" :key="index" :class="getClass(index)">
          <report-item :report="report" :showItems="showItems"></report-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
let BACK_END_PATH = process.env.VUE_APP_BACK_END_PATH

import ReportItem from '@/components/generic/output/ReportItem'

export default {
  data() {
    return {
      userCode: '',
      showItems: {},
      reportsList: [],
      optionShow: false,
      error: '',
    }
  },
  created() {
    let myLocalItem = window.localStorage.getItem('showItems')
    if (!myLocalItem) {
      this.showItems = {
        animatorName: true,
        activitiesDetails: true,
        appreciationRating: true,
        appreciationDetails: true,
        hadBugs: true,
        bugsDetails: true,
        establishment: true,
        fromTime: true,
        toTime: true,
        participantCount: true,
        remarks: true,
        type: true,
      }
    } else {
      this.showItems = JSON.parse(myLocalItem)
    }
  },
  watch: {
    showItems: {
      handler: function(newValue) {
        this.countFalse = 0
        for (const val in newValue) {
          if (!newValue[val]) {
            this.countFalse++
          }
        }
        let reportElemToShow = document.querySelectorAll('.reportElemToShow p')
        let report = document.querySelectorAll('.report p')

        for (let i = 0; i < reportElemToShow.length; i++) {
          reportElemToShow[i].style.width =
            window.innerWidth / (11 - this.countFalse) + 'px'
        }
        for (let i = 0; i < report.length; i++) {
          report[i].style.width =
            window.innerWidth / (11 - this.countFalse) + 'px'
        }

        window.localStorage.setItem('showItems', JSON.stringify(newValue))
      },
      deep: true,
    },
  },
  methods: {
    getClass(id) {
      return id % 2 ? 'odd' : 'even'
    },
    async getMyReports() {
      let data = JSON.stringify({ code: this.userCode })
      await axios({
        url: `${BACK_END_PATH}/myRepport`,
        method: 'post',
        data,
      }).then(r => {
        if (r.data.error) {
          this.error = r.data.error
        } else {
          for (let user in r.data) {
            r.data[user].visible = true
          }
          this.reportsList = r.data
        }
      })
    },
  },
  components: {
    ReportItem,
  },
}
</script>

<style>
.userCodeShowReport {
  height: 90vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.inputMargin {
  margin: 10px 0;
}
</style>
